import withStyles from "@mui/styles/withStyles";
import { Box, Button } from "@mui/material";
import Stepper from "@mui/material/Stepper";
import StepLabel from "@mui/material/StepLabel";
import Step from "@mui/material/Step";

import FullScreenModal from "components/common/FullScreenModal";
import log from "loglevel";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import filmReleaseService from "../../services/filmReleaseService";
import { useStyles } from "./AdvTable/tableStyles";
import AdvertisementCloneTable from "./AdvertisementCloneTable";
import SelectFilmRelease from "./SelectFilmRelease";
import { SelectedAdvSelector, actions as formActions } from "./logic/formActions";
import {handleServerErrors} from "core/exceptions";
const steps = ["Check for advertisements selection", "Select film release and contact"];
const maxStep = steps.length - 1;
function AdvertisementCloneDialog({ open, handleClose }) {
    const dispatch = useDispatch();
    const [value, setValue] = useState(null);
    const [selectedFilmRelease, setSelectedFilmRelease] = useState(null);
    const [selectedContact, setSelectedContact] = useState(null);

    const selectedAdv = useSelector(SelectedAdvSelector);
    const [step, setStep] = useState(0);

    const handleConfirm = async () => {
        try {
            await filmReleaseService.cloneAdv({
                advertisementsIds: selectedAdv.map((adv) => adv.id),
                contactId: selectedContact.id,
                nextFilmRelease: selectedFilmRelease.id,
                prevFilmRelease: selectedAdv[0].filmRelease.id,
            });

            toast.success("The advertisements has been successfully cloned", {
                position: "top-center"
            });

            dispatch(formActions.CLOSE_SELECTION.call());
            handleClose();
            dispatch(formActions.REFRESH_TABLE.send());
        } catch (error) {
            log.error(error);
            handleServerErrors(error, () => {
                toast.error("There was an error when cloning", {
                    position: "top-center"
                });
            })

        }
    };

    const handleNextStep = () => {
        setStep((step) => (step === maxStep ? step : step + 1));
    };
    const handlePreviousStep = () => {
        setStep((step) => (step === 0 ? step : step - 1));
    };

    const sameFilmReleaseWarning = selectedAdv[0]?.filmRelease?.id === selectedFilmRelease?.id;

    return (
        <FullScreenModal title={"CLONE ADVERTISEMENTS"} open={open} handleClose={handleClose}>
            <Box px={"40px"} py="30px" width="100%" maxWidth={"1200px"} marginX={"auto"}>
                <Box sx={{ width: "100%" }}>
                    <Stepper activeStep={step} alternativeLabel>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>

                    {step === 0 && (
                        <Box>
                            <Box maxHeight={"700px"} overflow={"auto"}>
                                <AdvertisementCloneTable />
                            </Box>
                        </Box>
                    )}

                    {step === 1 && (
                        <Box width="700px" marginX="auto">
                            <SelectFilmRelease
                                value={value}
                                selectedFilmRelease={selectedFilmRelease}
                                selectedContact={selectedContact}
                                setSelectedContact={setSelectedContact}
                                setSelectedFilmRelease={setSelectedFilmRelease}
                                setValue={setValue}
                                selectProps={{
                                    defaultMenuPortalTarget:true
                                }}
                                showWarning={sameFilmReleaseWarning}
                            />
                        </Box>
                    )}

                    <Box
                        mt={"15px"}
                        display={"flex"}
                        justifyContent={"flex-end"}
                        width={"100%"}
                        mx={"auto"}
                        style={{
                            gap: "20px",
                            maxWidth: step === 1 ? "700px" : "100%",
                        }}
                    >
                        <Button variant="outlined" onClick={handlePreviousStep} disabled={step === 0}>
                            Previous
                        </Button>
                        <Button variant="outlined" onClick={handleNextStep} disabled={maxStep === step}>
                            Next
                        </Button>

                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={handleConfirm}
                            disabled={!value || !selectedContact || sameFilmReleaseWarning}
                        >
                            Confirm
                        </Button>
                    </Box>
                </Box>
            </Box>
        </FullScreenModal>
    );
}

export default withStyles(useStyles)(AdvertisementCloneDialog);
